import moment from 'moment';
import { i18n } from '../main';

const validRules = {
  //必須チェック
  required: (v) => !!v || i18n.t('requiredField'),
  // 最大文字数チェック
  maxLength: (max) => {
    return (v) => {
      return v === undefined || v === null || v.length <= max || i18n.t('exceedMaxCharacters', { max });
    };
  },
  // 未来日付チェック
  isAfterDate: (date) => {
    return (v) => {
      if (!date || !v) {
        return true;
      }
      return moment(v).isSameOrBefore(moment(date)) || i18n.t('inappropriateDate');
    };
  },
  // 過去日付チェック
  isBeforeDate: (date) => {
    return (v) => {
      if (!date || !v) {
        return true;
      }
      return moment(v).isSameOrAfter(moment(date)) || i18n.t('inappropriateDate');
    };
  },
  // ファイルサイズチェック
  maxBytes: (max) => {
    return (v) => {
      return !v || v.size < max * 1000000 || i18n.t('fileSizeIsOver');
    };
  },
  // PDFチェック
  isPDF: (v) => {
    // 拡張子でPDFか判断
    if (v === undefined || v === null) {
      return true;
    }
    const filename = v.name;
    if (filename.endsWith('.pdf') || filename.endsWith('.PDF')) {
      return true;
    }
    return i18n.t('onlyAcceptPdfFiles');
  },
};

export default {
  data() {
    return {
      validator: validRules,
    };
  },
};
